import cropApplicationDrafts from "./cropApplicationDrafts";

const cropApplicationDraftService = [{
    matcher: 'cropApplicationDrafts',
    reply: config => {
    return [200, cropApplicationDrafts];
}
},{
    matcher: /cropApplicationDrafts\/(.*)/,
        reply : config => {
        const id = /cropApplicationDrafts\/(.*)/.exec(config.url)[1];
        const data = cropApplicationDrafts.find(item => item.appNo === id);
        return [200, data];
    }
}
]

export default cropApplicationDraftService;